import {
  BookOpen,
  Calendar,
  Check,
  Eye,
  FileText,
  Home,
  MoreHorizontal,
  Target,
  User,
  Users,
  UsersRound,
} from 'lucide-preact';
import type { ComponentChildren } from 'preact';

/**
 * Icon set.
 *
 * The original app inlined eleven hand-copied SVGs in an object called `I`,
 * then patched them into the nav with a `document.body.innerHTML.replace()`
 * on placeholder strings. Those paths were Lucide's to begin with, so this is
 * a direct swap — tree-shaken, and no string surgery on the document.
 */
export const Icons = {
  home: Home,
  cal: Calendar,
  users: Users,
  target: Target,
  more: MoreHorizontal,
  user: User,
  eye: Eye,
  check: Check,
  note: FileText,
  meeting: UsersRound,
  book: BookOpen,
} as const;

export type IconName = keyof typeof Icons;

interface IconProps {
  name: IconName;
  size?: number;
  class?: string;
}

export function Icon({ name, size = 24, class: className }: IconProps) {
  const Component = Icons[name];
  return <Component size={size} class={className} aria-hidden="true" />;
}

/** The rounded tinted square that carries an icon on cards and shortcuts. */
export function IconWrap({
  name,
  background,
  children,
}: {
  name?: IconName;
  background: string;
  children?: ComponentChildren;
}) {
  return (
    <div class="ic" style={{ background }}>
      {name ? <Icon name={name} /> : children}
    </div>
  );
}
